import React from 'react'

export default function Headingtxt(props) {
  return (
    <>
    <div className='heading'> {props.headingtxt}</div>
    
    </>
  )
}
